
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cbse-class-6-12",
      function () {
        return require("private-next-pages/cbse-class-6-12/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cbse-class-6-12"])
      });
    }
  